import {extendsAPIServices} from "./APIServices";
import getEnv from "../../helpers/common/getEnv";
import {POST} from "../../constants/HTTPConstants";

const baseAdminAPI = getEnv('baseAdminAPI');
const api = extendsAPIServices(baseAdminAPI);

export const _upload = (data) => {
    return api.makeAuthRequest({
        method: POST,
        url: '/media/upload',
        data
    });
};


// WEBPACK FOOTER //
// ./src/services/apis/UploadServices.js